import React, {useEffect, useState} from 'react';
import TextControl from './TextControl';
import SelectControl from './SelectControl';
/*
Si label no está definido, con la funcion convertSnakeCaseToText convierto el atributo name en label
*/
const TextControlObligado = ({ value, attributeModelName, handleInput, declarado=true, label, type='text', options=[], hasLabel=true, margin='mb-3', disabled=false, autocompletar=false, required=false }) => {
  const [inputType, setInputType] = useState('text')

  useEffect(() => {

    if (type && type.length > 0) {
      setInputType(type)
      // if( type !== 'date'){
      //   setInputType(type)
      // } else {
      //   setInputType(undefined)
      // }
    } else {
      setInputType('text')
    }
  }, [type]);

  return (
    <>
    {
      inputType && (
        <>
          {
            inputType === 'select' ? (
              <SelectControl
                value={options.includes(value) ? value : ''}
                options={options}
                required={required}
                name={attributeModelName}
                handleInput={handleInput}
                disabled={disabled}
                label={label}
              />
            ) : (
              <>
                {
                  inputType === 'file' ? (
                    <input
                      placeholder={label}
                      className="form-control"
                      onChange={handleInput}
                      name={attributeModelName}
                      type={inputType}
                      id={attributeModelName}
                      multiple
                    />
                  ) : (
                    <>
                    {inputType === 'leyend' ?
                    (<div className="alert alert-warning" role="alert">
                      {value}
                    </div>) :
                    (
                    <TextControl
                      value={autocompletar && value}
                      name={attributeModelName}
                      handleInput={handleInput}
                      label={label}
                      type={inputType}
                      hasLabel={hasLabel}
                      margin={margin}
                      disabled={disabled}
                    />)}
                    </>
                  )
                }

              </>

            )
          }

        </>
      )
    }
     </>
  );
};

export default TextControlObligado;